// reduxStoreInitializePromise.js
'use strict';

export let reduxStoreInitializeResolve;

/**
 * Pending redux store Initialized
 *
 * Resolves immediately since the legacy webpack app does not need
 * to wait for an async initClient action (that pattern was Next.js-specific).
 */
const createReduxStoreInitializePromise = () =>
  new Promise(resolve => {
    reduxStoreInitializeResolve = resolve;
    resolve();
  });

export const reduxStoreInitializePromise = createReduxStoreInitializePromise();

export default reduxStoreInitializePromise;
